import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Clock, TrendingUp, TrendingDown } from 'lucide-react';

// Always use tradepayflow.emergent.host for bonbot.biz custom domain
const getApiUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'bonbot.biz' || hostname === 'www.bonbot.biz') {
    return 'https://bonbot.biz/api';
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  return `${backendUrl}/api`;
};

const API = getApiUrl();

const TradeHistory = () => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTradeHistory();
    const interval = setInterval(fetchTradeHistory, 10000); // Update every 10 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchTradeHistory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/trades/history?limit=20`);
      setTrades(response.data.trades || []);
    } catch (error) {
      console.error('Error fetching trade history:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="trade-history-card" data-testid="trade-history-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5" />
          Trade History
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading && trades.length === 0 ? (
          <p className="text-muted-foreground" data-testid="loading-text">Loading trades...</p>
        ) : trades.length === 0 ? (
          <p className="text-muted-foreground" data-testid="no-trades-text">No trades yet</p>
        ) : (
          <div className="trades-list" data-testid="trades-list">
            {trades.map((trade, index) => (
              <div key={index} className="trade-item" data-testid={`trade-item-${index}`}>
                <div className="trade-info">
                  <div className="trade-direction">
                    {trade.direction === 'call' ? (
                      <TrendingUp className="w-4 h-4 text-emerald-500" data-testid="trade-call-icon" />
                    ) : (
                      <TrendingDown className="w-4 h-4 text-rose-500" data-testid="trade-put-icon" />
                    )}
                    <span className="trade-asset" data-testid="trade-asset">{trade.asset}</span>
                  </div>
                  <span className="trade-amount" data-testid="trade-amount">${trade.amount}</span>
                </div>
                <div className="trade-meta">
                  <span className="trade-time" data-testid="trade-time">
                    {new Date(trade.timestamp).toLocaleTimeString()}
                  </span>
                  <Badge 
                    variant={trade.status === 'win' ? 'default' : trade.status === 'loss' ? 'destructive' : 'secondary'}
                    data-testid="trade-status-badge"
                  >
                    {trade.status}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TradeHistory;
